<template>
  <div id="app" v-if="loaded">
    <div class="wrapper">
    <header style="text-align: center;">
        <img width="102" height="32" src="./assets/wizz.png">
        <h1>Make new friends</h1>
    </header>
    <section id="post">
        <section id="user">
            <img v-if="hasAvatar" class="avatar" width="50" height="50" :src="post.owner.thumbnailUrl">
            <div v-else class="emptyAvatar">{{post.owner.name.substring(0,2).toUpperCase()}}</div>
            <span class="pseudo">{{post.owner.name}}</span><br>
            <span class="date">{{getDate()}}</span>
        </section>
        <section id="message">
            <p v-if="post.text">{{post.text}}</p>
            <img v-if="post.imageUrl" :src="post.imageUrl">
        </section>
        <section id="reactions" v-if="post.reactions.length">
            <button v-for="reaction in post.reactions" :disabled="reaction.selected"  v-bind:class="{ active: reaction.selected}" @click="incrementReaction(reaction)">{{reaction.emoji}} {{reaction.count}}</button>
        </section>
        <section id="chatbar">
            <textarea v-model="comment" id="comment" placeholder="Add a comment"></textarea>
            <button><img width="28" height="25" src="./assets/send.png" @click="sendComment(comment)"></button>
        </section>
    </section>
    <footer>
        <h2 class="dl-button"><a :href="link">Download the app</a></h2>
    </footer>
    </div>
  </div>

  <div v-else id="app">
    <div id="overlay">
        <div id="overlay-content">
            <img src="./assets/appicon.jpg" width="100" height="100">
            <p>Start getting reactions on Snapchat now</p>
            <h2 class="dl-button"><a :href="link">Download the app</a></h2>
            <h2 v-if="loaded" class="dl-button"><a :href="link">Download the app</a></h2>
            
        </div>
    </div>
</div>
</template>

<script>

import moment from 'moment'
import { getPost, reactToReaction, sendComment, createSnapUser } from './scripts/firebase'

const snapUserID = `${Math.floor(Math.random() * 10000000)}`
export default {
  name: 'App',
    data () {
    return {
      hasAvatar: false,
      loaded: false,
      comment: '',
      link: 'https://itunes.apple.com/fr/app/id1452906710?mt=8',
      post: null,
      snapUser: {
        name: 'Snapchat user',
        username: 'snap' + snapUserID,
        description: 'This user is from Snapchat',
        imageUrl: 'https://storage.getwizz.io/appImage/snap-logo.png',
        thumbnailUrl: 'https://storage.getwizz.io/appImage/snap-logo.png',
        userID: snapUserID
      }
    }
  },
  watch: {
      $route() {
        console.log(this.$route);
      }
  },
  methods: {
    getDate() {
        return moment(new Date(this.post.creationDate*1000), "YYYYMMDD").fromNow()
    },
    incrementReaction(reaction) {
        if (!reaction.selected) {
            reaction.count = reaction.count + 1
            reaction.selected = true
        }
        mixpanel.track("Snaphtml_reaction_sent", reaction);
        reactToReaction(reaction.reactionID, this.post, this.$route.params.postId, this.snapUser)
    },
    sendComment(comment) {
        if (!comment) { return; } 
        
        mixpanel.track("Snaphtml_comment_sent", {"message": comment});

        if (!this.post.commentSent) {
            this.post.commentSent
        
            sendComment(comment, this.snapUser, this.post, this.$route.params.postId).then(() => {
                this.loaded = false
            })
        }
    }
  },
    mounted() {     
        getPost(this.$route.params.postId).then(post => {
            this.post = post
            this.hasAvatar = post.owner.thumbnailUrl ? true : false
            this.loaded = true
        })
  },
  updated() {
    this.$nextTick(function () {
        mixpanel.track_links("a", "Snaphtml_download_clicked");
    })
  }
}

mixpanel.track("Snaphtml_webview_opened");

</script>
    <style>
        html,
        body {
            width: 100%;
          
            background-color: #FFF;

            margin: 0;
            padding: 0;
            border: 0;
            font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        }
        #app {

        }
        #post {
            padding: 20px;
        }
        .avatar, .emptyAvatar {
            float: left;
            border-radius: 25px;
            margin-right: 10px;
        }
        .emptyAvatar {
            display: inline-block;
            width: 50px;
            height: 50px;
            background-color: lightgray;
            text-align: center;
            line-height: 50px;
            color: rgba(255,255,255,0.9);
            font-weight: bold;
            font-size: 20px;
        }
        h1 {
            font-size: 16px;
        }
        p {
            font-size: 18px;
            padding: 0;
            margin: 0;
        }
        a {
            color: inherit;
            text-decoration: none;
        }
        .date {
            font-size: 12px;
            color: gray;
        }
        .pseudo {
            font-size: 16px;
            font-weight: bold;
        }
        #user {
            height: 50px;
        }
        #user text {
            display: inline-block;
            vertical-align: middle;
        }
        #message {
            padding: 20px 0 16px 0;
        }
        #message img {
            display: inline-block;
            width: 100%;
            border-radius: 5px;
        }
        #overlay {
            background-color: #FFF;
            background-repeat: repeat;
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 999;
            text-align: center;
        }
        #overlay-content {
            padding: 100px 20px;
        }
        #overlay .dl-button {
            margin-top: 30px;
            background-color: rgb(0, 121, 254) !important;
        }
        #overlay p {
            margin-top: 30px;
            font-weight: bold;
            font-size: 22px
        }
        #overlay img {
            border-radius: 24px;
            -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.2);
            box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.2);
        }

        header {
            padding-top: 16px;
            border-bottom: 1px solid rgb(238, 238, 238);
        }
        footer {
            color: #FFF;
            height: 80px;
            text-align: center;
            margin-bottom: 60px;
        }
        .dl-button {
            color: #FFF;
            -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.2);
            box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.2);
            border-radius: 14px;
            width: calc(100% - 40px);
            background-color: rgb(0, 121, 254);
            font-weight: bold;
            font-size: 16px;
            display: inline-block;
            vertical-align: middle;
            line-height: 80px;
        }
        .dl-button a {
            display: inline-block;
            width: 100%;
            height: 100%;
        }
        #chatbar {
            height: 54px;
            position: relative;
        }
        #chatbar button {
            background: none;
            border:none;
            right: 15px;
            top: 12px;
            display: inline-block;
            width: 28px;
            height: 25px;
            position: absolute;
            padding-right: 35px;
        }
        #reactions {
            height: 40px;
            padding-bottom: 26px;
        }
        #reactions button {
            margin-right: 6px;
            color: rgb(199, 199, 199);
            height: 100%;
            font-weight: 500;
            font-size: 18px;
            background-color: #FFF;
            border-radius: 8px;
            padding-left: 8px;
            padding-right: 8px;
            border: 1px solid rgb(238, 238, 238);
        }
        #reactions button.active {
            color: black;
            border-color: rgb(174, 197, 220);
            background-color: rgb(236.0, 240, 243, 0.5);
        }
        button {
            -webkit-appearance: none;
        }
        textarea {
            -webkit-appearance: none;
            position: absolute;
            width: calc(100% - 70px);
    
            height: 35px;
            border: 1px solid gray;
            border-radius: 25px;
            border-color: rgb(238, 238, 238);
            font-size: 15px;
            padding-left: 20px;
            padding-right: 50px;
    
            padding-top: 15px;
            font-size: 15px;
            resize: none;
        }
        ::-webkit-input-placeholder {
            color: rgb(199, 199, 199);
            font-size: 15px;
            font-weight: 600;
            padding-left: 5px;
            text-align: left;
        }
    </style>


// WEBPACK FOOTER //
// src/App.vue